import React from 'react';

import { SimpleFetcher } from 'components/Fetcher';

const PasswordReqs = ({ reset, className }) => (
    <SimpleFetcher
        url={'password-requirements/'}
        method='options'
        render={({ responseData })=> (
            <ul className={`list-unstyled ${className}`}>
                {responseData.map(requirement => <li>{requirement}</li>)}
            </ul>
        )}
    />
);

export default PasswordReqs;
